import React, { useState } from "react";
import "./JobRole.css";

const jobs = [
  {
    title: "Regional Manager",
    openings: 3,
    ctc: "₹15,00,000 per annum",
    desc: `
Regional Manager – Role & Responsibilities
Role Overview :

A Regional Manager is responsible for overseeing business operations across an assigned region, ensuring sales growth, team performance, compliance, and customer satisfaction. The role focuses on strategic execution, leadership, and regional expansion.

Lead and manage daily operations of the assigned unit/branch

Achieve sales targets for insurance, mutual funds, SIPs, loans, and related products

Recruit, train, and manage a team to achieve business .
`
  },
  {
    title: "Unit Manager",
    openings: 6,
    ctc: "₹11,00,000 per annum",
    desc: `
Unit Manager – Role & Responsibilities

Role Overview :

A Unit Manager is responsible for managing a specific business unit or branch, focusing on sales growth, team development, customer service, and compliance with company policies. The role acts as a key link between frontline teams and regional management.

Lead and manage daily operations of the assigned unit/branch

Achieve sales targets for insurance, mutual funds, SIPs, loans, and related products

Recruit, train, and manage a team to achieve business.
`
  },
  {
    title: "Senior Category Manager",
    openings: 2,
    ctc: "₹8,50,000 per annum",
    desc: `
Senior Category Manager – Role & Responsibilities

Role Overview : 

A Senior Category Manager is responsible for leading and optimizing a specific business category or product segment across the organization. The role focuses on strategy, performance growth, market positioning, team leadership, and profitability of the assigned category.

Key Responsibilities :

Develop and execute category-level strategies aligned with company goals

Drive revenue growth and profitability for the assigned category

Analyze market trends, customer needs, and competitor activities

Oversee product mix, pricing strategy, and performance optimization

Coordinate with sales, marketing, operations, and compliance teams

Monitor category-wise MIS, KPIs, and performance reports.
`
  },
  {
    title: "Category Manager",
    openings: 4,
    ctc: "₹6,00,000 per annum",
    desc: `
Category Manager – Role & Responsibilities

Role Overview  :

A Category Manager is responsible for managing and growing a specific product or service category. The role focuses on category performance, sales growth, market positioning, coordination with internal teams, and ensuring profitability and compliance.

Key Responsibilities :

Manage end-to-end performance of the assigned category

Drive sales targets and revenue growth for the category

Analyze market trends, customer needs, and competitor activities.
`
  },
  {
    title: "Executive Manager",
    openings: 15,
    ctc: "₹4,00,000 per annum",
    desc: `
Executive Manager – Role & Responsibilities

Role Overview :

An Executive Manager is responsible for planning, directing, and overseeing business operations to achieve organizational goals. The role combines strategic execution, leadership, performance management, and cross-functional coordination.

Key Responsibilities :

Execute business strategies and operational plans

Drive revenue growth, productivity, and profitability .
`
  }
];



export default function JobRole() {
  const [open, setOpen] = useState(false);
  const [role, setRole] = useState("");
  const [formData, setFormData] = useState({
    fullName: "",
    age: "",
    education: "",
    email: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const message = `Hello, I'm applying for ${role}.
Name: ${formData.fullName}
Age: ${formData.age}
Education: ${formData.education}
Email: ${formData.email}`;

    window.open(
      `https://wa.me/7200039384?text=${encodeURIComponent(message)}`,
      "_blank"
    );

    setOpen(false);
    setFormData({ fullName: "", age: "", education: "", email: "" });
  };

  return (
    <>
      <section className="jobs-wrapper">
        <h2 className="jobs-title">
          Current Openings <span></span>
        </h2>

        {jobs.map((job, index) => (
          <div className="job-card" key={index}>
            <div className="job-header">
              <h3>{job.title}</h3>
              <span className="openings">{job.openings} Openings</span>
            </div>

            <p className="job-ctc">
              <strong>CTC:</strong> {job.ctc}
            </p>

            <div className="job-desc">
              {job.desc
                .trim()
                .split("\n\n")
                .map((block, i) => {
                  const text = block.trim();

                  if (text === "Role Overview:") {
                    return (
                      <h4 key={i} className="job-subtitle">
                        Role Overview
                      </h4>
                    );
                  }

                  if (text === "Key Responsibilities:") {
                    return (
                      <h4 key={i} className="job-subtitle">
                        Key Responsibilities
                      </h4>
                    );
                  }

                  return (
                    <p key={i} className="job-text">
                      {text}
                    </p>
                  );
                })}
            </div>

            <button
              className="apply-btn"
              onClick={() => {
                setRole(job.title);
                setOpen(true);
              }}
            >
              Apply Now
            </button>
          </div>
        ))}
      </section>

      {open && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>Apply for {role}</h3>

            <form className="popup-form" onSubmit={handleFormSubmit}>
              <input
                name="fullName"
                placeholder="Full Name"
                value={formData.fullName}
                onChange={handleInputChange}
                required
              />
              <input
                name="age"
                type="number"
                placeholder="Age"
                value={formData.age}
                onChange={handleInputChange}
                required
              />
              <input
                name="education"
                placeholder="Education"
                value={formData.education}
                onChange={handleInputChange}
                required
              />
              <input
                name="email"
                type="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              <input value={role} readOnly className="readonly" />

              <div className="popup-actions">
                <button type="submit">Send via WhatsApp</button>
                <button
                  type="button"
                  className="cancel"
                  onClick={() => setOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
